module.exports = __webpack_public_path__ + "img/lesson_06.c4c2d3e0.jpg";